const scratchCardRu = {
  'scratchCard': {
    'codeLabel': 'Код со скретч-карты',
    'description': 'Введите код № {{codeNumber}} с вашей \nскретч-карты {{card}}',
    'keysInformation': 'Количество доступных ключей: {{availableKeysCount}}',
    'confirm': 'Подтвердить',
    'errors': {
      'scratch_card_code_invalid': 'Код введен неверно. Попробуйте еще',
      'scratch_card_code_is_block': 'Код заблокирован. Введите другой',
    },
  },
};

export default scratchCardRu;
